module.exports = __webpack_public_path__ + "static/media/sword.c5edfc8a.png";